module.exports = __webpack_public_path__ + "static/img/success.c561c39d.png";